import React from 'react';
import './Footer.css';
import {AiFillBehanceCircle} from 'react-icons/ai';
import {AiOutlineGithub} from 'react-icons/ai';
import {BsLinkedin} from 'react-icons/bs';
import { FaBehance } from 'react-icons/fa';
import { FiGithub, FiLinkedin } from 'react-icons/fi';


const Footer = () => {
  return (
    <footer>
        <a href="#" className='footer__logo'> eltonalexander </a>

        <ul className='permalinks'>
          <li> <a href="#"> Home </a></li>
          <li> <a href="#about"> About </a></li>
          <li> <a href="#experience"> Experience </a></li>
          <li> <a href="#portfolio"> Portfolio </a></li>
          <li> <a href="#testimonials"> Testimonials</a></li>
          <li> <a href="#contact"> Contact </a></li>                 
          </ul>

          <div className='footer__socials'>
            
            <a href = "https://www.behance.net/eltonajadi" target="_blank"> <FaBehance /> </a>
            <a href = "https://github.com/eltonalexanderajadi" target="_blank">  <FiGithub /> </a>
            <a href = "https://www.linkedin.com/in/elton-alexander-ajadi-a55137239/" target="_blank"> <FiLinkedin /> </a>
          </div>

          <div className='footer__copyright'>
            <small> &copy; eltonalexander. All rights reserved. </small>  
          </div>  
    </footer>
  )
}

export default Footer;